<template>
    <div class="sidebar">
        <div class="sidebar-brand">
            <router-link to="/cabinet">
                <img src="../assets/img/Dark.svg" alt="SuperQR" width="130" height="40">
            </router-link>
        </div>
        <nav class="sidebar-nav">
            <div class="nav-section">
                <span class="nav-section-title">
                    <i class="bi bi-grid"></i>
                    {{ $t('sidebar.menu') }}
                </span>
                <router-link class="sidebar-link" to="/cabinet">
                    <i class="bi bi-house"></i>
                    <span>{{ $t('sidebar.cabinet') }}</span>
                </router-link>
                <router-link class="sidebar-link" :to="role === 'admin' ? '/plans' : '/plans-table'">
                    <i class="bi bi-piggy-bank"></i>
                    <span>{{ $t('sidebar.plans') }}</span>
                </router-link>
                <router-link v-if="role === 'admin'" class="sidebar-link" to="/modules">
                    <i class="bi bi-diagram-2"></i>
                    <span>{{ $t('sidebar.modules') }}</span>
                </router-link>
                <router-link v-if="role === 'admin'" class="sidebar-link" to="/spheres">
                    <i class="bi bi-diagram-3"></i>
                    <span>{{ $t('sidebar.spheres') }}</span>
                </router-link>
                <router-link v-if="role === 'admin'" class="sidebar-link" to="/briefs">
                    <i class="bi bi-clipboard-check"></i>
                    <span>{{ $t('sidebar.briefs') }}</span>
                </router-link>
                <router-link v-if="role === 'admin'" class="sidebar-link" to="/catalog">
                    <i class="bi bi-grid-3x3-gap"></i>
                    <span>{{ $t('sidebar.catalog') }}</span>
                </router-link>
                <router-link v-if="role === 'admin'" class="sidebar-link" to="/users">
                    <i class="bi bi-people"></i>
                    <span>{{ $t('sidebar.users') }}</span>
                </router-link>
            </div>
        </nav>
        <div class="sidebar-footer">
            <a class="sidebar-link cabinet-back" href="https://cabinet.superqr.com/cabinet">
                <i class="bi bi-arrow-left-circle"></i>
                <span>{{ $t('sidebar.backToCabinet') }}</span>
            </a>
            <a class="sidebar-link" href="#" @click.prevent="logout">
                <i class="bi bi-box-arrow-left"></i>
                <span>{{ $t('sidebar.logout') }}</span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        role: ''
    }),
    async mounted() {
        await this.getRole()
    },
    methods: {
        async logout() {
            let response = await this.$api.logout()
            if(response.result === 'SUCCESS') {
                this.$router.push('/login')
            }
        },
        async getRole() {
            let r = await this.$api.getUser()
            if(r.result === 'SUCCESS') {
                this.role = r.data.role
            }
        }
    }
}
</script>

<style scoped>
.sidebar {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
    background: #fff;
}

.sidebar-brand {
    height: 64px;
    display: flex;
    align-items: center;
    padding: 0 1.5em;
    border-bottom: 1px solid #e5e7eb;
}

.sidebar-brand a {
    text-decoration: none;
}

.sidebar-nav {
    flex: 1;
    padding: 18px 12px;
    overflow-y: auto;
}

.nav-section-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #475569;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    padding: 0 12px;
    margin-bottom: 10px;
}

.nav-section-title i {
    font-size: 14px;
    color: #7c3aed;
}

.sidebar-link {
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 9px 12px;
    border-radius: 10px;
    color: #475569;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    transition: background-color 0.15s ease, color 0.15s ease;
    margin-bottom: 2px;
}

.sidebar-link:hover {
    background-color: #f8fafc;
    color: #0f172a;
}

.sidebar-link .bi {
    font-size: 17px;
    width: 20px;
    text-align: center;
    transition: color 0.15s ease;
}

.sidebar-link.router-link-active {
    background-color: #faf7ff;
    color: #6d28d9;
    font-weight: 600;
}

.sidebar-link.router-link-active::before {
    content: '';
    position: absolute;
    left: -2px;
    top: 6px;
    bottom: 6px;
    width: 3px;
    border-radius: 0 3px 3px 0;
    background: #7c3aed;
}

.sidebar-link.router-link-active .bi {
    color: #7c3aed;
}

.sidebar-footer {
    padding: 12px;
    border-top: 1px solid #e5e7eb;
}

.sidebar-footer .sidebar-link {
    color: #64748b;
}

.sidebar-footer .sidebar-link:hover {
    color: #ef4444;
    background-color: #fef2f2;
}

.sidebar-footer .cabinet-back {
    color: #7c3aed;
}

.sidebar-footer .cabinet-back:hover {
    color: #6d28d9;
    background-color: #faf7ff;
}
</style>
